<template>
  <div class="container" :class="[mode, menuDesktopState]">
    <header>
      <slot name="header">
        <Header/>
      </slot>
    </header>
    <aside>
      <slot name="aside">
        <Menu v-if="!$appUtils.isMobile()"/>
      </slot>
    </aside>
    <main>
      <slot name="main">main</slot>
    </main>
    <footer v-if="$slots.footer">
      <slot name="footer">footer</slot>
    </footer>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Menu from '@/components/Menu'
import {mapGetters} from 'vuex'

export default {
  name: "DefaultTmpl",
  props: {
    mode: {
      type: String,
      default: 'default',
      validator(val) {
        return /(default|mobile_search)/.test(val)
      }
    }
  },
  components: {Header, Menu},
  computed: {
    ...mapGetters(['menuDesktopState'])
  }
}
</script>

<style scoped lang="scss">
@import "../assets/css/variables";

.container {
  display: grid;
  grid-template-columns: $aside_desktop_width auto;
  min-height: 100vh;
  transition: all .3s ease;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0) rgba(0, 0, 0, 0);

  &:hover {
    scrollbar-color: rgba(0, 0, 0, 0.5) rgba(0, 0, 0, 0);

    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.5);
    }
  }

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0);
    border-radius: 10px;
    transition: background 0.3s ease-in-out;
  }


  &.default {
    grid-template-rows: 50px auto 50px;
    grid-template-areas: 'aside header'
            'aside main'
            'aside footer'
  }

  &.collapsed {
    grid-template-columns: 50px auto;
  }

  &.mobile_search {
    grid-template-rows: 50px auto;
    grid-template-areas: 'aside header'
            'aside main'
  }

  header {
    grid-area: header;
    position: sticky;
    top: 0;
    z-index: 2;
  }

  aside {
    grid-area: aside;
    background: $theme_color_three;
    color: #fff;
    transition: all .3s ease;
  }

  main {
    grid-area: main;
    background: $theme_color_four;
    scroll-behavior: smooth;
  }

  footer {
    grid-area: footer;
  }
}

@media only screen and (max-width: 576px) {
  .container.mobile_search {
    grid-template-columns: 1fr;
    grid-template-rows: 50px auto;
    grid-template-areas: 'header header' 'main main';
  }

  header {
  }

  main {
    overflow-y: scroll;
  }

  footer {
    position: fixed;
    width: 100%;
    height: 60px;
    bottom: 0;
    background: $theme_color_three;
    color: #fff;
  }
}

</style>
